import { Model } from 'dva'

const initialState = {
  currentCampaign: null,
}

const CampaignManager: Model = {
  namespace: 'campaignManager',
  state: initialState,
  effects: {},
  reducers: {
    setCurrentCampaign(state, action) {
      return {
        ...state,
        currentCampaign: action.payload,
      }
    },
    updateCurrentCampaign(state, action) {
      return {
        ...state,
        currentCampaign: {
          ...state.currentCampaign,
          ...action.payload,
        },
      }
    },
    resetCampaignManager(state, action) {
      return {
        ...state,
        ...initialState,
      }
    },
  },
}

export default CampaignManager
